import classNames from 'classnames';
import { motion } from 'framer-motion';
import React, { useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';

interface Props {
	children: React.ReactNode;
	className?: string;
}

const StyledContent = styled(motion.div)`
	overflow: hidden;
`;

export function AnimateChangeInHeight({ children, className }: Props) {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const [height, setHeight] = useState<number | 'auto'>('auto');

	useLayoutEffect(() => {
		if (containerRef.current) {
			const resizeObserver = new ResizeObserver((entries) => {
				// We only have one entry, so we can use entries[0].
				let observedHeight: 'auto' | number = entries[0].contentRect.height;
				if (observedHeight === 0) {
					observedHeight = 'auto';
				}

				setHeight(observedHeight);
			});

			resizeObserver.observe(containerRef.current);

			return () => {
				resizeObserver.disconnect();
			};
		}
	}, []);

	return (
		<StyledContent className={classNames(className)} style={{ height }} animate={{ height }} transition={{ duration: 0.2 }}>
			<div ref={containerRef}>{children}</div>
		</StyledContent>
	);
}
